// extracted by mini-css-extract-plugin
export default {"form_label_margin":"0 0 5px 0"};